import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-warm" data-id="element-312" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "18px"
    }} data-id="element-313" data-mp="3fym6mihn2y3a">
        <h2 className="text-center font-display text-3xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-314" data-mp="3b1chl3y5wofz">
          Deportistas reales. Experiencias reales.
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-315" data-mp="31zd3ajej7ygq">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.05} data-id="element-316" data-mp="2x004r1eat2yb" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}